import React, { useState, useEffect } from "react";
import { Card, Table, Tooltip, Button, Row, Col, message } from "antd";
import { DeleteFilled, EditFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import 'antd/dist/antd.css';
import { isValidValue, setFormFieldValue } from "../../../../../helpers/FormHelper";
import { getIndividFullName } from "../../../../../helpers/ObjectHelper";
import { getErrorMessage } from "../../../../../helpers/ErrorHelper";
import { ErrorCard } from "../../PatronageReferred/voters-list/components/List";
import ConfirmDeleteModal from "../../../../../components/Common/Modals/ConfirmDeleteModal";
import EmigrantService from "../../../../../services/Election/EmigrantService";
import moment from "moment";
import { setRowNumber } from "../../../../../helpers/MainHelper";
import { upperCaseString } from "../../../../../helpers/StringFormatter";



const List = ({ dispatch, items, totalCount, initialPagination, isLoading, errorMessage, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modalResetNumber, setModalResetNumber] = useState({ deleteModal: 0 });


    const initialPaginationTable = {
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20, 25],
        pageSize: initialPagination.pageSize,
        current: initialPagination.currentPage,
        total: totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
    };


    const [paginationTable, setPaginationTable] = useState(
        initialPaginationTable
    );


    useEffect(() => {
        setPaginationTable({
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 15, 20, 25],
            pageSize: initialPagination.pageSize,
            current: initialPagination.currentPage,
            total: totalCount,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
    }, [initialPagination, totalCount]);


    const handleTableChange = (pagination, filters, sorter) => {
        setPaginationTable({
            ...pagination,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
        const action = {
            type: "set_table_pagination",
            payload: {
                pageSize: pagination.pageSize,
                currentPage: pagination.current,
            }
        };
        dispatch(action);
    };


    const openDeleteModal = (item) => {
        setItem(item);
        setDeleteModal(true);
    };


    const closeDeleteModal = () => {
        setItem(null);
        setDeleteModal(false);
        setModalResetNumber({
            ...modalResetNumber,
            deleteModal: modalResetNumber.deleteModal + 1
        });
    };


    const onDelete = async () => {
        const emigrantId = item?.id;
        const isValidEmigrant = isValidValue(emigrantId);
        if (isValidEmigrant === false) {
            await message.error("Emigranti nuk gjendet!", 2);
            return;
        }

        setLoading(true);
        try {
            const response = await EmigrantService.delete(token, emigrantId);
            const apiResponse = response.data;
            console.log(apiResponse);
            await message.success("Fshirja u krye me sukses!", 1);
            onSuccess();
        } catch (error) {
            const errorMessage = getErrorMessage(error);
            await message.error(errorMessage, 2);
        } finally {
            closeDeleteModal();
            setLoading(false);
        }
    };


    const openView = (item) => {
        const action = {
            type: "open_view",
            payload: {
                item: item,
                index: 2
            }
        };
        dispatch(action);
    };


    const tableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            align: "center",
            width: 50,
            render: (value) => <b>{value}.</b>,
        },
        {
            title: "Shteti",
            width: 120,
            render: (_, elm) => setFormFieldValue(elm?.country?.country_name),
        },
        {
            title: "Qyteti i emigrimit",
            dataIndex: "city",
            width: 150,
        },
        {
            title: "Qyteti i origjinës",
            dataIndex: "city_albania",
            width: 150,
        },
        {
            title: "Emri",
            dataIndex: "name",
            width: 150,
        },
        {
            title: "Mbiemri",
            dataIndex: "surname",
            width: 150,
        },
        {
            title: "Telefoni",
            dataIndex: "phone",
            width: 150,
        },
        {
            title: "Referuar nga",
            dataIndex: "referues_name",
            width: 180,
        },
        {
            title: "Dt. e regjistrimit",
            dataIndex: "create_date",
            align: 'center',
            width: 140,
            render: (value) => moment(value).format('DD-MM-YYYY, HH:mm'),
        },
        {
            title: "Veprime",
            dataIndex: "actions",
            align: "center",
            fixed: 'right',
            className: 'm-0 p-0',
            width: 100,
            render: (_, elm) => (
                <div style={{ fontSize: "20px", backgroundColor: '#fff' }} className="p-2">
                    <Tooltip title="Modifiko">
                        <Button
                            type="primary"
                            className="mr-3"
                            onClick={() => openView(elm)}
                            icon={<EditFilled />}
                        />
                    </Tooltip>
                    <Tooltip title="Fshi">
                        <Button
                            danger
                            onClick={() => openDeleteModal(elm)}
                            icon={<DeleteFilled />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "0px" }}>
                            <div className="table-responsive">
                                <Table
                                    size="small"
                                    columns={tableColumns}
                                    rowKey="id"
                                    bordered="true"
                                    dataSource={setRowNumber(items)}
                                    pagination={paginationTable}
                                    loading={isLoading}
                                    locale={{ emptyText: errorMessage ? <ErrorCard message={errorMessage} /> : null }}
                                    onChange={handleTableChange}
                                    scroll={{ x: 1200 }}
                                    showHeader="true"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <ConfirmDeleteModal
                            isOpen={deleteModal}
                            title={`Jeni të sigurtë që doni të fshini referencën:`}
                            subtitle={`${upperCaseString(getIndividFullName(item))}`}
                            loading={loading}
                            onConfirm={onDelete}
                            onClose={closeDeleteModal}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default List;